import { useIsFeatureEnabled } from "./useIsFeatureEnabled";
import { CHANGE_MEETING_OWNER } from "./props";

export function useChangeMeetingOwner() {
  return useIsFeatureEnabled(CHANGE_MEETING_OWNER);
}
